module.exports = __webpack_public_path__ + "img/bulb.4863a3ef.svg";